import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './index.module.scss'
import { align } from '../../core/styles'
import { ether } from '../../core'

class FocusBox extends React.Component {
  constructor() {
    super()
    this.select = this.select.bind(this)
  }

  select() {
    this.onSelect && this.onSelect()
  }

  render() {
    const { children, className, heading, color, onSelect } = this.props
    this.onSelect = onSelect
    return (
      <div onClick={this.select} className={ classnames(className, styles.focusbox, onSelect && styles.selectable, color && styles['color-'+color]) }>
        { heading && ( <div className={ classnames(styles.heading, ether('p-y-spacer-md')) }>{ heading }</div> ) }
        <div className={ classnames(styles.focusboxInner, align.center) }>{ children }</div>
      </div>
    )
  }
}


FocusBox.propTypes = {
  heading: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
}

export default FocusBox
